import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { TrophyIcon, PlayIcon } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
function LazyWistiaVertical({
  videoId,
  title
}: {
  videoId: string;
  title: string;
}) {
  const [load, setLoad] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setLoad(true);
        observer.disconnect();
      }
    }, {
      rootMargin: '300px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className="absolute inset-0 w-full h-full bg-black" data-id="element-303">
      {load ? <iframe src={`https://fast.wistia.net/embed/iframe/${videoId}?web_component=true&seo=false`} title={title} allow="autoplay; fullscreen" frameBorder="0" scrolling="no" className="absolute inset-0 w-full h-full" data-id="element-304" /> : <div className="absolute inset-0 flex items-center justify-center" data-id="element-305">
          <div className="w-14 h-14 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center" data-id="element-306">
            <PlayIcon className="w-7 h-7 text-white fill-white" data-id="element-307" />
          </div>
        </div>}
    </div>;
}
export function TestimonialSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  return <section className="py-24 relative overflow-hidden bg-[#020202]" data-id="element-308">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-purple-900/10 blur-[120px] rounded-full pointer-events-none" data-id="element-309" />

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-310">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-311">
          <div className="text-center mb-16" data-id="element-312">
            <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/20 text-yellow-400 px-4 py-2 rounded-full text-sm font-bold mb-8" data-id="element-313">
              <TrophyIcon className="w-4 h-4" data-id="element-314" />
              <span data-id="element-315">Casos de Éxito</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-316">
              Resultados reales de usuarios reales
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-317">
              Mirá cómo otros ya están escalando con 100ads.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 max-w-4xl mx-auto" data-id="element-318">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={isVisible ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            delay: 0.2,
            duration: 0.5
          }} className="flex flex-col items-center" data-id="element-319">
              <div className="relative w-full max-w-[300px] md:max-w-[320px] aspect-[9/16] bg-black rounded-[28px] border-4 border-white/10 shadow-[0_20px_80px_rgba(0,0,0,0.5)] overflow-hidden mb-6" data-id="element-320">
                <LazyWistiaVertical videoId="w7eb1734dg" title="Caso de éxito Santiago Bilbao" data-id="element-321" />
              </div>
              <h3 className="text-lg font-bold text-white mb-1" data-id="element-322">
                Santiago Bilbao
              </h3>
              <p className="text-sm text-purple-400 font-medium mb-2" data-id="element-323">
                Founder de Launch Expert
              </p>
              <p className="text-sm text-gray-400 text-center max-w-[280px]" data-id="element-324">
                +90 alumnos generaron miles de dólares usando estos mismos
                creativos.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={isVisible ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            delay: 0.4,
            duration: 0.5
          }} className="flex flex-col items-center" data-id="element-325">
              <div className="relative w-full max-w-[300px] md:max-w-[320px] aspect-[9/16] bg-black rounded-[28px] border-4 border-white/10 shadow-[0_20px_80px_rgba(0,0,0,0.5)] overflow-hidden mb-6" data-id="element-326">
                <LazyWistiaVertical videoId="1ffvh1yddh" title="Caso de éxito Leo Paez" data-id="element-327" />
              </div>
              <h3 className="text-lg font-bold text-white mb-1" data-id="element-328">Leo Paez</h3>
              <p className="text-sm text-purple-400 font-medium mb-2" data-id="element-329">
                Co-Founder de FEM Academy
              </p>
              <p className="text-sm text-gray-400 text-center max-w-[280px]" data-id="element-330">
                Escala sus campañas con creativos generados en minutos.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}